import { HttpErrorResponse } from '@angular/common/http';

/** Domain-level reason a sign-in attempt failed. */
export type AuthErrorKey = 'invalidCredentials' | 'unknown';

/** Translation key shown to the user for each reason. */
export const AUTH_ERROR_MESSAGE_KEYS: Record<AuthErrorKey, string> = {
  invalidCredentials: 'views.security.login.message.error',
  unknown: 'views.security.login.message.unknownError',
};

/**
 * Maps a failed `/connect/token` call to a domain reason. The endpoint answers
 * 400/403 with `{ error: 'invalid_grant' }` when the account does not exist or
 * the password does not match; anything else (network, CORS, 5xx) is unknown.
 */
export function toAuthErrorKey(error: unknown): AuthErrorKey {
  if (error instanceof HttpErrorResponse && (error.status === 400 || error.status === 403)) {
    return 'invalidCredentials';
  }
  return 'unknown';
}
